(() => {
  if (window.yfProductLinksReady) return;
  window.yfProductLinksReady = true;
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-yf-size-guide], [data-yf-review-link]');
    if (!link) return;
    const isSize = link.hasAttribute('data-yf-size-guide');
    const target = isSize
      ? document.getElementById(link.hash.slice(1))
      : document.getElementById('judgeme_product_reviews') || document.querySelector('.jdgm-review-widget');
    if (!target) return;
    event.preventDefault();
    if (isSize) target.open = true;
    for (let parent = target.parentElement; parent; parent = parent.parentElement) {
      if (parent.tagName === 'DETAILS') parent.open = true;
    }
    const focusTarget = isSize ? target.querySelector('summary') : target;
    if (focusTarget) {
      if (!isSize) focusTarget.setAttribute('tabindex', '-1');
      focusTarget.focus({preventScroll:true});
    }
    target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});
  });
})();
